export default "__VITE_ASSET__53e3e499__"